<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="grp-card create-grp" @click="createUser">
        <img src="@/assets/icons/add.svg" />
        <div>Create New Group</div>
      </div>
      <div class="grp-card" v-for="(grp, index) in groups" :key="index">
        <div class="card-wrapper">
          <div class="grp-name">{{grp.name}}</div>
          <h5>Details</h5>

          <div class="grp-creator">
            <span style="font-weight:600">Created By:</span>
            {{grp.creator}}
          </div>
          <div class="grp-date">
            <span style="font-weight:600">Date:</span>
            {{getDate(grp.created)}}
          </div>
          <p class="grp-desc">
            <span style="font-weight:600">Description:</span>
            <br />
            {{grp.description}}
          </p>
        </div>
        <div class="edit-group">
          <button @click="EditGroup(grp)">Edit</button>
          <br />
          <button @click="DeleteGroup(grp)">Delete</button>
        </div>
      </div>
      <div class="grp-card empty-grp" v-for="index in 5" :key="index"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "configgrp",
  data() {
    return {};
  },
  computed: {
    groups() {
      return this.$store.state.commGroups;
    },
    noEditFlag() {
      return this.$route.path.includes("/edit");
    }
  },
  methods: {
    createUser(obj) {
      this.$router.push("/app/secure/group/create");
    },
    EditGroup(obj) {
      this.$store.dispatch("showLoader", false);

      this.$store.commit("setCGroupId", obj._id.$oid);
      this.$store.dispatch("getCGroup", obj._id.$oid);
      var uri = encodeURI("/app/secure/group/edit/" + obj.name);
      // console.log(uri);

      this.$router.push(uri);
    },
    async DeleteGroup(obj) {
      var r = confirm(`delete ${obj.name}?`);

      if (r) {
        var logData = this.createLogData(obj);

        await this.$store.dispatch("deleteCGroup", obj._id.$oid);
        await this.$store.dispatch("AddUserLog", logData);
        this.$store.dispatch("getCGroups");
      }
    },
    createLogData(obj) {
      let cmdGroup = _.clone(obj);
      var LogData = {
        user: this.$store.state.user,
        collection: "commodity_group ",
        mode: "delete",
        record: cmdGroup._id.$oid.toString(),
        fields: [],
        newValue: [],
        oldValue: []
      };
      delete cmdGroup._id;
      delete cmdGroup.created;
      for (let key in cmdGroup) {
        LogData.fields.push(key);
        LogData.oldValue.push(cmdGroup[key]);
      }
      return LogData;
    },
    getDate(obj) {
      var dt = new Date(obj.$date).toDateString();
      // console.log(dt);
      return dt.substring(4);
    }
  },
  async created() {
    this.$store.commit("changePathLabel", {
      view: "Configure Groups",
      categories: [{ name: "All Groups", focus: true }]
    });
    await this.$store.dispatch("getCGroups");
    this.groups;
    this.$store.dispatch("showLoader", false);
  }
};
</script>

<style scoped>
.grp-card {
  position: relative;
  height: 250px;
  width: 210px;
  background: #868690;
  background-size: cover;
  border-radius: 4px;
  margin: 0px 5px 50px 15px;
  padding: 0;
  font-size: 12px;
  overflow: hidden;
  color: #ffffe8;
}

.row {
  padding: 0px 20px 0px 20px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.create-grp {
  background: #868690;
  border-radius: 4px;
  padding: 0px;
  color: #ffffe8;
}

.create-grp:hover {
  box-shadow: 0px 2px 25px #5559;
}
.card-wrapper {
  width: 100%;
  height: 100%;
  /* background: #00000080; */
  margin: 0;
  padding: 15px 10px 15px 10px;
}
.empty-grp {
  background: transparent;
}

.create-grp > img {
  width: 210px;
  padding: 55px;
}

.create-grp div {
  margin: 0 auto;
  width: max-content;
  font-weight: 300;
  font-size: 18px;
  color: #ffffe8;
}

.grp-name {
  margin-bottom: 32px !important;
  font-weight: 600;
  font-size: 18px;
}

.grp-desc {
  height: 50px;
  overflow: hidden;
}

.edit-group {
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 0px !important;
  height: 250px;
  width: 210px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  /* background: #00000080; */
  transition: 0.2s;
}
.grp-card:hover .card-wrapper,
.card-wrapper:hover,
.card-wrapper:hover div {
  display: none;
}
.edit-group:hover {
  opacity: 1;
}

.edit-group button {
  border: 1px solid #fff;
  border-radius: 4px;
  color: #fff;
  width: 92px;
  height: 38px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
